import {guid} from '../util/helpers'

const fields = {
  basic: []
}

function seed () {
  const basic = [
    { name: 'Zdjęcie (124px x 124px)', type: 'text', value: '' },
    { name: 'Imię i nazwisko *', type: 'text', value: '' },
    { name: 'Stanowisko *', type: 'text', value: '' },
    { name: 'Adres e-mail *', type: 'email', value: '@develtio.com' },
    { name: 'Numer telefonu *', type: 'text', value: '+48 22 847 09 52' },
    { name: 'Adres biura *', type: 'select', value:
        [
          { text: 'ul. Al. Jerozolimskie 181B / 5 piętro, 02-222 Warszawa' },
          { text: 'ul. Jesionowa 22 lok 3.5, 40-158 Katowice' }
      ]
    }
  ]

  basic.forEach(item => {
    fields.basic.push({ ...item, id: guid() })
  })
}

seed()

export default fields
